module.exports = __webpack_public_path__ + "static/media/plantScan.ae725a31.png";